// extracted by mini-css-extract-plugin
module.exports = {"tooltipIcon":"TextHelper_tooltipIcon__2L9ig"};